<template>
    <div class="container mb-4">
        <ConfirmationModal modalId="resetServiceGroupModal" triggerEventName="resetServiceGroup" />
        <h6 class="font-weight-bold" v-html="TEXTS.render(`SELECT_SERVICE_GROUP_HEADER`)"></h6>
        <h6 class="mb-4" v-html="serviceGroupSubheading"></h6>
        <div class="row justify-content-left">
            <ServiceButtonCard 
                v-for="(serviceGroup, i) in serviceGroups" 
                :key="i" 
                :serviceGroup="serviceGroup" 
                :selectedServiceGroupId="selectedServiceGroupId"
                @click.native="selectServiceGroup(serviceGroup)"
                @keyEvent="selectServiceGroup(serviceGroup)"
                />
        </div>
        <div style="line-height: 1.3;" v-html="serviceGroupFooter"></div>
    </div>
</template>

<script>
    import ResidentPortalFilter from '../../../../common/utils/ResidentPortalFilter';
    import ConfirmationModal from '../../../../common/components/ConfirmationModal';
    import ServiceButtonCard from './ServiceButtonCard';
    import Helper from '../../../../helper'
    import Texts from '../../../../common/utils/Texts'
    import { validateRequiredSpecialOptions } from '../helper';

    export default {
        props: {
            easySwitch: Boolean
        },
        components : {
            ConfirmationModal,
            ServiceButtonCard
        },
        data() {
            return {
                isMounted: false,
                // progressPercent: 0,
                pubPath: process.env.MIX_APP_URL,
                hasColor: true,
                hasTriggeredAutoSelect: false,
            };
        },
        computed:{
            TEXTS: ()=> Texts,
            bookingState : function(){
                return this.$store.getters.GET_BOOKING_STATE
            },
            activeAddress : function(){
                return this.$store.getters.GET_BOOKING_STATE.activeAddress; 
            },
            activeAddressSetting : function(){
                return this.$store.getters.GET_BOOKING_STATE.activeAddressSetting;
            },
            selectedServiceGroupId : function(){
                var selectedServiceGroup = this.$store.getters.GET_BOOKING_STATE.selectedServiceGroup;
                return selectedServiceGroup != null ? selectedServiceGroup.service_group_id : null;
            },
            serviceGroups: function() { // Returns a list of service groups 
                // Required Data
                var availableServiceGroups = this.$store.getters.GET_SERVICE_GROUP.list;
                // Get the Selected Address -- Hard Requirement
                if(!this.activeAddress){
                    return;
                }

                // Filter by Address Setting -- Soft Requirement
                if(this.activeAddressSetting){
                    if(this.activeAddressSetting.is_display == 0 || this.activeAddressSetting.is_display == 2){ // Default to Nothing if Is Display is 0 OR 2; Impossible Scenario
                        return [];
                    }
                    else if(this.activeAddressSetting.service_group){
                        availableServiceGroups = availableServiceGroups.filter(serviceGroup => {
                            for (let i = 0; i < this.activeAddressSetting.service_group.length; i++) {
                                const excludedServiceGroup = this.activeAddressSetting.service_group[i];
                                if(excludedServiceGroup.service_group_id == serviceGroup.service_group_id){
                                    return false;
                                }
                            }
                            return true;
                        })
                    }
                }

                // Filter by User 
                var portalFilter = new ResidentPortalFilter();
                var userType = this.$store.getters.GET_PERSONAL_INFO.type;
                availableServiceGroups = portalFilter.filterCollectionByUserType(availableServiceGroups, userType)
                // Auto Select the service group if there's only one available

                // --- Auto Select if an AutoSelect
                if(!this.hasTriggeredAutoSelect && this.autoSelectServiceId && this.serviceMap[this.autoSelectServiceId]){
                    var foundServiceGroup = availableServiceGroups.find(serviceGroup => serviceGroup.service_group_id == this.serviceMap[this.autoSelectServiceId])
                    if(foundServiceGroup){
                        var self = this
                        setTimeout(function() {
                            self.hasTriggeredAutoSelect = true
                        }, 3000)
                        this.$store.dispatch("setBookingState", { isAgreedToTerms : "yes", bypassTerms : true});
                        this.selectServiceGroup(foundServiceGroup, true)
                        // --- Mark Terms and Agreements as accepted
                    }
                }

                if(availableServiceGroups.length == 1){
                    this.selectServiceGroup(availableServiceGroups[0])
                }
                // Sort
                availableServiceGroups.sort((a, b) =>{
                    return a.order - b.order;
                })
                
                return availableServiceGroups;
            },
            serviceCardStyle: function(){
                var btnTextColor = this.$store.getters["GET_MAIN_UI"].button_text_color;
                var btnBackgroundColor = this.$store.getters["GET_MAIN_UI"].button_color;

                return this.isCompleted ? {
                    "button-color": btnTextColor,
                    "background-color": btnBackgroundColor,
                } : null;
            },
            searchInstructionSettings(){
                var searchInstructionSettings = this.$store.getters.GET_SEARCH_INSTRUCTION_SETTINGS
                return this.$store.getters.GET_SEARCH_INSTRUCTION_SETTINGS
            },
            siteWordings() {
                return this.$store.getters['GET_SITE_WORDINGS']; 
            },
            serviceGroupWording() {
                return this.$store.getters['GET_SERVICE_GROUP_WORDING']; 
            },
            serviceGroupSubheading(){
                if(this.siteWordings && this.siteWordings.service_group_subheading){
                    return this.siteWordings.service_group_subheading
                }
                else {
                    return Texts.render(`SELECT_SERVICE_GROUP_SUBHEADER`) 
                }
            },
            selectedServiceGroupWording(){
                var selectedServiceGroup = this.$store.getters.GET_BOOKING_STATE.selectedServiceGroup;
                return selectedServiceGroup ? selectedServiceGroup.wording : null
            },
            serviceGroupFooter() {
                return this.selectedServiceGroupWording ? 
                    this.selectedServiceGroupWording.content : 
                    Texts.render(`SELECT_SERVICE_GROUP_FOOTER`, this.selectedServiceGroupNameCondensed, null, {skipCasing : true})
            },
            serviceMap(){
                var map = {}
                const availableServices = this.$store.getters.GET_SERVICES.list;

                if(!Array.isArray(availableServices))
                return map

                availableServices.forEach(service => map[service.service_setting_id] = service.service_group_id)
                return map
            },
            autoSelectServiceId(){
                /*
                    Stry: [US458] As a CSO, I want the service and beginning terms to be auto selected
                    Date: 2021-02-10
                    Auth: Franco Mapua
                    Desc: Retrieving any auto selection code from the general settings
                */
                var userType = this.$store.getters.GET_PERSONAL_INFO.type;
                if(userType != `cso`){
                    return
                }

                const { is_autoselect_for_cso, autoselect_service_setting_id } = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING || { is_autoselect_for_cso: false, autoselect_service_setting_id: null }

                if(is_autoselect_for_cso == 1 && autoselect_service_setting_id) {
                    return autoselect_service_setting_id
                }
            },
            selectedServiceGroupNameCondensed(){
                var selectedServiceGroup = this.$store.getters.GET_BOOKING_STATE.selectedServiceGroup;
                if(selectedServiceGroup && selectedServiceGroup.group_name){
                    let trimmedName = selectedServiceGroup.group_name.toLowerCase().trim().replace(/\ /g, '')
                    if(trimmedName.indexOf('hardwastecollection') > -1){
                        return 'hardwastecollection'
                    }
                    else if(trimmedName.indexOf('missedcollection') > -1){
                        return 'missedcollection'
                    }
                    else if(trimmedName.indexOf('binrepair') > -1 || trimmedName.indexOf('binmaintenance') > -1){
                        return 'binmaintenance'
                    }
                }
            },
        },
        mounted() {
            // this.$store.dispatch('getSiteWordingsSettings');
            this.$store.dispatch('getServiceGroupWording');
            this.$store.dispatch('getServiceGroup');

            let self = this;
            this.$parent.$on('forceSelectServiceGroup', function(targetService) {
                if (!self.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;
                self.changeServiceGroup(self, targetService);
            });
        },
        methods: {
            selectServiceGroup(serviceGroup, bypass) {
                if(!serviceGroup || serviceGroup.is_disabled){
                    return
                }
                // Get Existing Service ID if it exists
                var currentSelection = this.bookingState.selectedServiceGroup ? this.bookingState.selectedServiceGroup.service_group_id : null

                // Get Wordings
                if(currentSelection && currentSelection == serviceGroup.service_group_id){
                    return
                } else {
                    if(!bypass){
                        this.$store.dispatch("setBookingState", { bypassTerms : false});
                    }
                    var self = this; // storing reference
                    
                    if(this.bookingState.selectedServiceGroup){
                        if (this.$store.state.serviceGroup.list.length > 1) {
                            if (!this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) {
                                this.$emit(
                                    "resetServiceGroup",  
                                    "Changing your selected service will discard your changes below. Would you like to continue?",
                                    function(){ // If the user said yes
                                        self.changeServiceGroup(self, serviceGroup);
                                    },
                                    function(){ // If the user said no

                                    })
                            } else {
                                if (this.selectedServiceGroupId !== serviceGroup.service_group_id) {
                                    // Check current view selected products && stored multi service booking products
                                    
                                    var GET_BOOKING_PRODUCTS = this.$store.getters.GET_BOOKING_PRODUCTS
                                    var GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED = this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
                                    var level1EmptyStreams = GET_BOOKING_PRODUCTS.filter(product => !product.hasVariation && product.qty == -1)
                                    var isMultiServiceParentEmpty = GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED && level1EmptyStreams.length > 0

                                    const checkSpecialOptionResult = validateRequiredSpecialOptions(this.$store.getters);
                                    if (checkSpecialOptionResult.result === false) {
                                        this.$emit('showAlert', checkSpecialOptionResult.message || this.TEXTS.render(`SERVICE_SWITCH_VALIDATION_INCOMPLETE`, null, { yourItem: `required option` }));
                                        return;
                                    }

                                    if (this.$store.getters.GET_HAS_PARENT_WASTES_SELECTED_AND_EMPTY_CURRENT_SERVICE_WASTES || this.$store.getters.GET_HAS_PARENT_WASTES_SELECTED || isMultiServiceParentEmpty) {
                                        this.$emit('showAlert', this.TEXTS.render(`SERVICE_SWITCH_VALIDATION_INCOMPLETE`, null, { yourItem: `waste type` }));
                                        return;
                                    }
                                    // Check if current service has booking dates stored in multi service booking dates
                                    else if (this.$store.getters.GET_HAS_CURRENT_SERVICE_WASTES_AND_EMPTY_CURRENT_SERVICE_DATES) {
                                        this.$emit('showAlert', this.TEXTS.render(`SERVICE_SWITCH_VALIDATION_INCOMPLETE`, null, { yourItem: `collection date` }));
                                        return;
                                    }

                                    if (!this.easySwitch
                                        && this.$store.getters.GET_CURRENT_SERVICE_GROUP_WASTES.length > 0
                                        && this.$store.getters.GET_CURRENT_SERVICE_GROUP_DATES.length > 0) {
                                        // If easy switching is not allowed
                                        // Prompt the question to clear the selected products under current selected service group
                                        this.$emit('showConfirm', serviceGroup);
                                        return;
                                    }

                                    // Easy switching between service groups
                                    // Switch to new selected service group
                                    this.changeServiceGroup(self, serviceGroup);
                                }
                            }
                        }
                    }else{  // If there isn't a selected Service yet
                        this.changeServiceGroup(self, serviceGroup);
                    }

                    if (this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) {
                        // Reset easy service group switching without prompting for clearing current selected service group
                        this.$emit('setEasySwitch', false);
                    }
                }
            },
            changeServiceGroup(self, serviceGroup){
                if(self.serviceGroupWording && Array.isArray(self.serviceGroupWording)){
                    var wording = self.serviceGroupWording.find(wording =>{
                        return wording.service_group == serviceGroup.service_group_id
                    })
                    serviceGroup.wording = wording
                }
                var bookingState = self.bookingState; // Shallow Cloning
                // bookingState.activeAddressSetting =  self.activeAddressSetting;
                bookingState.selectedServiceGroup =  serviceGroup;
                bookingState.selectedService =  null;
                bookingState.isAgreedToTerms =  null;
                bookingState.hasEndTerms =  null;
                self.$store.dispatch('resetActiveServiceSetting', null);
                self.$store.dispatch('setActiveServiceGroup', serviceGroup);
                self.$store.dispatch("setBookingState", bookingState);
                self.$emit('nextsection')
            }
        }
    }
</script>
